import request from '@/utils/request'

//获取虚拟仿真模块列表
export function getvrmodulelist(params) {
    return request({
        url: '/portal/vr-module/get-list',
        method: 'GET',
        params
    })
}